import { render, staticRenderFns } from "./TemplatesPreview.vue?vue&type=template&id=5e5de3da&scoped=true&"
import script from "./TemplatesPreview.vue?vue&type=script&lang=js&"
export * from "./TemplatesPreview.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesPreview.vue?vue&type=style&index=0&id=5e5de3da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5de3da",
  null
  
)

export default component.exports